// removed by extract-text-webpack-plugin
module.exports = {"item":"src-styles-components----portfolio-module---item---2bT7E","image":"src-styles-components----portfolio-module---image---2HNcP","background":"src-styles-components----portfolio-module---background---2Vty3","titleWrapper":"src-styles-components----portfolio-module---titleWrapper---3XK6v","title":"src-styles-components----portfolio-module---title---1gVmS"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/portfolio.module.scss
// module id = 87
// module chunks = 221574975059773 236655976900686